<div class="product-info-container info-card mb-4">
  <div class="card-header">
    @if (title) {
      <span class="card-title mb-0"> {{ title }} </span>
    }
  </div>
  <mat-accordion multi>
    @for (record of recordDetail; track record; let i = $index) {
      <mat-expansion-panel
        [expanded]="openPanels.includes(i)"
        (opened)="openPanel(i)"
        (closed)="closePanel(i)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> {{ record[panelVar] }} </mat-panel-title>
          <mat-panel-description>
            Click to {{ openPanels.includes(i) ? 'Hide' : 'View' }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="table-container">
          <table class="vertical col-12">
            <tbody>
              @for (infoPoint of infoKey; track infoPoint.label) {
                <tr>
                  <th>{{ infoPoint.label }}</th>
                  <td [class.empty-cell]="emptyCellCheck(record, infoPoint)">
                    @if (
                      infoPoint.varSet &&
                      record.Details &&
                      record.Details[infoPoint.varSet] &&
                      record.Details[infoPoint.varSet][infoPoint.varName]
                    ) {
                      @if (
                        infoPoint.valueMask && infoPoint.valueMask === 'date'
                      ) {
                        {{
                          record.Details[infoPoint.varSet][infoPoint.varName]
                            | date: 'shortDate'
                        }}
                      } @else if (
                        infoPoint.valueMask &&
                        infoPoint.valueMask === 'currency'
                      ) {
                        <span>
                          {{
                            record.Details[infoPoint.varSet][infoPoint.varName]
                              | currency
                          }}
                        </span>
                      } @else if (
                        infoPoint.valueMask && infoPoint.valueMask === 'percent'
                      ) {
                        <span>
                          {{
                            record.Details[infoPoint.varSet][infoPoint.varName]
                              | percent: '1.3'
                          }}
                        </span>
                      } @else if (infoPoint.key) {
                        {{
                          infoPoint.key[
                            record.Details[infoPoint.varSet][infoPoint.varName]
                          ]
                        }}
                      } @else {
                        {{
                          record.Details[infoPoint.varSet][infoPoint.varName]
                        }}
                      }
                    } @else if (
                      infoPoint.valueMask &&
                      infoPoint.valueMask === 'translateBool'
                    ) {
                      <span>
                        {{ record[infoPoint.varName] === true ? 'Yes' : 'No' }}
                      </span>
                    } @else if (
                      !infoPoint.varSet && record[infoPoint.varName]
                    ) {
                      @if (
                        infoPoint.valueMask && infoPoint.valueMask === 'date'
                      ) {
                        {{ record[infoPoint.varName] | date: 'shortDate' }}
                      } @else if (
                        infoPoint.valueMask &&
                        infoPoint.valueMask === 'currency'
                      ) {
                        <span>{{ record[infoPoint.varName] | currency }}</span>
                      } @else if (
                        infoPoint.valueMask && infoPoint.valueMask === 'percent'
                      ) {
                        <span>{{ record[infoPoint.varName] | percent }}</span>
                      } @else if (
                        infoPoint.decryptTarget &&
                        record[infoPoint.decryptTarget]
                      ) {
                        <span class="decrypt-cell">
                          {{ record[infoPoint.varName] }}

                          <button
                            type="button"
                            class="ms-1 decrypt-button"
                            mat-icon-button
                            matTooltip="Click to see raw value"
                            [matTooltipShowDelay]="500"
                            (click)="
                              decryptValue(
                                record[infoPoint.decryptTarget],
                                infoPoint.label
                              )
                            "
                          >
                            <mat-icon>lock_open</mat-icon>
                          </button>
                        </span>
                      } @else if (infoPoint.key) {
                        {{ infoPoint.key[record[infoPoint.varName]] }}
                      } @else {
                        {{ record[infoPoint.varName] }}
                      }
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
<ngx-loading [show]="loading" />
